//product images

import Swiper from 'swiper';
import { Zoom, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import "swiper/css/zoom";

console.log("portal-product.js loaded");

const html = document.documentElement;
const body = document.body;

const productForm = document.getElementById("product_form");
const stickyAddToBasketButton = document.getElementById("sticky_add_to_basket_button");

let sizeAndQuantitySelectorGroups, sizeAndQuantitySelectors, quantitySelectors, showPricing, product_images_swiper;
let basketData = [];

function updateStickyAddToBasket()
{

    const quantityFields = document.querySelectorAll(".quantity_selector_quantity_field");
    const stickyAddToBasketPanel = document.getElementById("sticky_add_to_basket_panel");
    const stickyAddToBasketButton = document.getElementById("sticky_add_to_basket_button");
    const stickyAddToBasketQuantity = stickyAddToBasketPanel.querySelector(".total_qty");
    const stickyAddToBasketSingular = stickyAddToBasketPanel.querySelector(".singular");
    const stickyAddToBasketPlural = stickyAddToBasketPanel.querySelector(".plural");
    
    let quantity = 0;
    quantityFields.forEach(input =>
    {
        quantity+=parseInt(input.value);
    });

    stickyAddToBasketQuantity.innerHTML = new Intl.NumberFormat().format(quantity);

    if (quantity < 1)
    {
        stickyAddToBasketPanel.classList.remove("ready");
        stickyAddToBasketButton.disabled = true;
        stickyAddToBasketQuantity.style.display = "inline";
        stickyAddToBasketSingular.style.display = "none";
        stickyAddToBasketPlural.style.display = "inline";
    }
    else
    {
        stickyAddToBasketPanel.classList.add("ready");
        stickyAddToBasketButton.disabled = false;
        stickyAddToBasketQuantity.style.display = "inline";
        stickyAddToBasketSingular.style.display = "inline";
        stickyAddToBasketPlural.style.display = "none";
        if (quantity ==1)
        {
            stickyAddToBasketQuantity.style.display = "inline";
            stickyAddToBasketSingular.style.display = "inline";
            stickyAddToBasketPlural.style.display = "none";
        }
        else
        {
            stickyAddToBasketQuantity.style.display = "inline";
            stickyAddToBasketSingular.style.display = "none";
            stickyAddToBasketPlural.style.display = "inline";
        }
    }

    const totals = buildBasketDataFromQuantitySelectors();

    if (showPricing)
    {
        const exVatPrice = window.displayPrice(totals[0]);
        const incVatPrice = window.displayPrice(totals[1]);
        stickyAddToBasketPanel.querySelector(".ex_vat_value").innerHTML = exVatPrice;
        stickyAddToBasketPanel.querySelector(".inc_vat_value").innerHTML = incVatPrice;
        if (totals[0] >= 1000)
        {
            document.getElementById("sticky_add_to_basket_price_and_delivery_estimate").classList.add("long_price");
        }
        else
        {
            document.getElementById("sticky_add_to_basket_price_and_delivery_estimate").classList.remove("long_price");
        }
    }

}

// Sums quantity fields across EVERY product card sharing the same base
// product (data-product-id) - not just the current card - so tier pricing
// combines correctly when the same base product is listed as more than one
// distinct PortalProduct (e.g. different colours/designs of one product).
function getPageQuantityTotalForProduct(productId)
{
    let total = 0;
    document.querySelectorAll(`article.product[data-product-id="${productId}"] .quantity_selector_quantity_field`).forEach(field => {
        total += field.valueAsNumber || 0;
    });
    return total;
}

// Resolves which tier <li> in a .price_break_list applies for a given
// quantity. Only relevant for products with real quantity price-break tiers
// (use_tier_pricing) - products without a .price_break_list never call this.
function getActivePortalPriceBreak(quantity, basketQty, articleEl)
{
    const effectiveQuantity = quantity + basketQty;
    const breaks = articleEl.querySelectorAll(".price_break_list li");
    let active = null;
    breaks.forEach(li =>
    {
        const min = parseInt(li.getAttribute("data-min"));
        const max = li.getAttribute("data-max") ? parseInt(li.getAttribute("data-max")) : null;
        if (max && effectiveQuantity > max) return;
        if (effectiveQuantity >= min) active = li;
    });
    return active;
}

// Highlights the currently-applicable tier (green, via the shared .active
// CSS rule) across EVERY product card sharing the same base product, and
// un-highlights the rest - so two differently-listed PortalProducts for the
// same base product stay visually in sync with each other.
function setActivePortalPriceBreak(productId, activeMin)
{
    document.querySelectorAll(`article.product[data-product-id="${productId}"] .price_break_list li`).forEach(li =>
    {
        li.classList.toggle("active", activeMin !== null && parseInt(li.getAttribute("data-min")) === activeMin);
    });
}

function buildBasketDataFromQuantitySelectors()
{
    let ex_vat_total = 0.00;
    let inc_vat_total = 0.00;
    let showAndCustomise = false; //hide 'and personalise' on add to basket button, set to true below

    basketData = [];

    sizeAndQuantitySelectors.forEach(sizeAndQuantitySelector =>
    {
        const quantityField = sizeAndQuantitySelector.querySelector(".quantity_selector_quantity_field");
        const quantity = quantityField.valueAsNumber;

        if (quantity > 0)
        {
            const variantbasketData = { "portal_variant_id" : parseInt(quantityField.getAttribute("name")), "quantity" : quantity};
            
            const product = sizeAndQuantitySelector.closest("article.product");

            const priceContainer = product.querySelector(".price_container");
            if (product.hasAttribute("data-personalisable"))
            {
                showAndCustomise = true;
            }
            if (priceContainer)
            {
                let ex_vat_price = parseFloat(priceContainer.querySelector(".ex_vat_price").getAttribute('data-raw'));
                let inc_vat_price = parseFloat(priceContainer.querySelector(".inc_vat_price").getAttribute('data-raw'));

                // Tier pricing: resolve the correct break for this product's
                // total pending + basket quantity, instead of always reading
                // the first (highest, qty-1) tier's price.
                const priceBreakList = product.querySelector(".price_break_list");
                if (priceBreakList)
                {
                    const basketQty = parseInt(product.getAttribute("data-basket-product-qty")) || 0;
                    const productId = product.getAttribute("data-product-id");
                    const productQuantity = getPageQuantityTotalForProduct(productId);
                    const activeBreak = getActivePortalPriceBreak(productQuantity, basketQty, product);

                    setActivePortalPriceBreak(productId, activeBreak ? parseInt(activeBreak.getAttribute("data-min")) : null);

                    if (activeBreak)
                    {
                        ex_vat_price = parseFloat(activeBreak.querySelector(".ex_vat_price").getAttribute("data-raw"));
                        inc_vat_price = parseFloat(activeBreak.querySelector(".inc_vat_price").getAttribute("data-raw"));
                    }
                }

                //does the quantity selector have its own price?

                const variant_price_container = sizeAndQuantitySelector.querySelector(".footer_slot .price");

                if (variant_price_container)
                {
                    ex_vat_price = variant_price_container.querySelector(".ex_vat_price").getAttribute("data-raw");
                    inc_vat_price = variant_price_container.querySelector(".inc_vat_price").getAttribute("data-raw");
                }

                const ex_vat_line_total = parseFloat(ex_vat_price * quantity);
                const inc_vat_line_total = parseFloat(inc_vat_price * quantity);

                ex_vat_total = ex_vat_total + ex_vat_line_total;
                inc_vat_total += inc_vat_line_total;
            }
            basketData.push(variantbasketData);
        }
    });
    if (showAndCustomise)
    {
        stickyAddToBasketButton.classList.add("and_customise");
    }
    else
    {
        stickyAddToBasketButton.classList.remove("and_customise");
    }
    return [ex_vat_total,inc_vat_total];
}

function addToBasket(basketDataToAdd = null)
{
    const token = document.querySelector("meta[name=csrf-token]").getAttribute("content");
    const url = productForm.getAttribute("action");

    if (basketDataToAdd === null)
    {
        basketDataToAdd = basketData;
    }

    stickyAddToBasketButton.classList.add("loading");
    stickyAddToBasketButton.disabled = true;
        
        fetch(url,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': token
            },
            body: JSON.stringify(basketDataToAdd)
        })
        .then(response => response.json())
        .then(result => 
        {
            if (result.success)
            {
                let message_html = "<div class='added_products'>";
                result.products.forEach(product => {
                    message_html += "<div class='added_product'>";
                    message_html += "<img src='"+product.thumb+"' alt='"+product.name+"' />";
                    message_html += "<div><strong>"+product.name+"</strong><br /><strong>"+product.size_and_quantity+"</strong></div>";
                    message_html += "</div>";
                });
                message_html += "</div>";

                let button_url = "#";
                let button_label = "Close";

                if (result.personalisation_route)
                {
                    button_url = result.personalisation_route;
                    button_label = "Personalise";
                }

                window.basketMessage("Added to Basket",message_html,button_url,button_label);
                stickyAddToBasketButton.classList.add("success");
                setTimeout(() => {
                    stickyAddToBasketButton.classList.remove("success");
                }, 1000);

                const quantityFields = document.querySelectorAll(".size_and_quantity_selectors .quantity_selector_quantity_field");
                quantityFields.forEach(input => {
                    input.value = 0;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                });
                if (result.basket_item_count)
                {
                    const basket_item_count = document.querySelector(".mini_basket_container .nav_link.basket .count");
                    basket_item_count.innerHTML = result.basket_item_count;
                    basket_item_count.classList.add('visible');
                }
            }
            else
            {
                let error = "<p>We could not add your selection to your basket. Please try again, or make another selection.</p>";
                if (result.error)
                {
                    error = result.error
                }
                window.basketError("Sorry",error);
                stickyAddToBasketButton.disabled = false;
            }

            stickyAddToBasketButton.classList.remove("loading");
            
        })
        .catch(error => {
            window.basketError("Sorry",error);
            stickyAddToBasketButton.classList.remove("loading");
            stickyAddToBasketButton.disabled = false;
        });

}

function initialiseSwiper()
{
    if (product_images_swiper instanceof Swiper)
    {
        product_images_swiper.destroy();
    }
    
    const allSwiperImages = document.querySelectorAll(".product_images_swiper img");

    allSwiperImages.forEach(swiperImage =>
    {
        swiperImage.dataset.regular_src = swiperImage.getAttribute("src");
        if (!swiperImage.dataset.zoom_src)
        {
            swiperImage.dataset.zoom_src = swiperImage.getAttribute("src");
        }
    });
    
    product_images_swiper = new Swiper('.product_images_swiper', {
        modules: [Zoom, Navigation, Pagination],
        direction: 'horizontal',
        loop: false,
        zoom: true,
        slidesPerView: 1,
    
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            },
            pagination: {
            el: ".swiper-pagination",
            clickable: true,
            },
    });
    
    const swiperZoomButton = document.querySelector(".swiper_zoom_button");
    
    swiperZoomButton.removeEventListener('click', zoomButtonClicked); //prevent duplicate listener
    swiperZoomButton.addEventListener('click',zoomButtonClicked);
    
    product_images_swiper.on('zoomChange',(product_images_swiper) =>
    {
        const activeSlide = product_images_swiper.slides[product_images_swiper.activeIndex];
        const activeImg = activeSlide.querySelector('img');
        const isZoomed = product_images_swiper.zoom.scale > 1; // Scale > 1 means zoomed
        if (isZoomed)
        {
            swiperZoomButton.classList.remove('zoomed');
            activeImg.setAttribute('src', activeImg.dataset.regular_src);
        }
        else
        {
            swiperZoomButton.classList.add('zoomed');
            activeImg.setAttribute('src', activeImg.dataset.zoom_src);
        }
    });
}

function zoomButtonClicked()
{
    if (product_images_swiper.zoom.enabled)
    {
        product_images_swiper.zoom.toggle();
    }
}


function fitSizeLabels() {
    document.querySelectorAll('.size_quantity_selector label span').forEach(span => {
        const label = span.parentElement;
        span.style.fontSize = '';
        const labelStyle = getComputedStyle(label);
        const availableWidth = label.clientWidth
            - parseFloat(labelStyle.paddingLeft)
            - parseFloat(labelStyle.paddingRight);
        if (span.offsetWidth > availableWidth) {
            span.style.fontSize = (availableWidth / span.offsetWidth) + 'em';
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    document.fonts.ready.then(fitSizeLabels);

    if (document.querySelector('.size_quantity_selector')) {
        window.startHeartbeat();
    }

    showPricing = document.documentElement.classList.contains("show_pricing");
    quantitySelectors = document.querySelectorAll(`.quantity_selector`);
    sizeAndQuantitySelectorGroups = document.querySelectorAll(`.size_and_quantity_selectors`);
    sizeAndQuantitySelectors = document.querySelectorAll(`.size_quantity_selector`);

    // quantitySelectors.forEach(quantitySelector => {

    //     quantitySelector.addEventListener('click',(event) => {
    //         event.preventDefault();
    //         if (event.target)
    //         {
    //             if (event.target.classList.contains('increase'))
    //             {
    //                 const increaseButton = event.target;
    //                 const quantityField = increaseButton.previousElementSibling;
    //                 const max = (quantityField.getAttribute("max")===false) ? -1 : parseInt(quantityField.getAttribute("max"));
    //                 const currentQuantity = parseInt(quantityField.value);
    //                 quantityField.value = (max > -1 && ((currentQuantity + 1) > max)) ? max : currentQuantity + 1;
    //                 quantityField.dispatchEvent(new Event('change', { bubbles: true }));
    //             }
    //             else if (event.target.classList.contains('decrease'))
    //             {
    //                 const decreaseButton = event.target;
    //                 const quantityField = decreaseButton.nextElementSibling;
    //                 const min = (quantityField.getAttribute("min")===false) ? 0 : parseInt(quantityField.getAttribute("min"));
    //                 const currentQuantity = parseInt(quantityField.value);
    //                 quantityField.value = ((currentQuantity - 1) < min) ? min : currentQuantity - 1;
    //                 quantityField.dispatchEvent(new Event('change', { bubbles: true }));
    //             }
    //         }
    //     });

    //     quantitySelector.addEventListener('change',(event) => {
    //         if (event.target)
    //         {
    //             if (event.target.classList.contains('quantity_selector_quantity_field'))
    //             {
    //                 const quantityField = event.target;
    //                 const min = (quantityField.getAttribute("min")===false) ? 0 : parseInt(quantityField.getAttribute("min"));
    //                 const max = (quantityField.getAttribute("max")===false) ? -1 : parseInt(quantityField.getAttribute("max"));
    //                 const decreaseButton = quantityField.previousElementSibling;
    //                 const increaseButton = quantityField.nextElementSibling;
    //                 const currentQuantity = parseInt((quantityField.value.trim()==="") ? 0 : quantityField.value);
    //                 if (currentQuantity <= min)
    //                 {
    //                     quantityField.value = min;
    //                     decreaseButton.disabled = true;
    //                 }
    //                 else
    //                 {
    //                     decreaseButton.disabled = false;
    //                 }
    //                 if (currentQuantity >= max)
    //                 {
    //                     quantityField.value = max;
    //                     increaseButton.disabled = true;
    //                 }
    //                 else
    //                 {
    //                     increaseButton.disabled = false;
    //                 }
    //             }
    //         }
    //     });
    // });
    //size and quantity selectors

    sizeAndQuantitySelectorGroups.forEach(sizeAndQuantitySelectorGroup =>
    {
        sizeAndQuantitySelectorGroup.addEventListener('click',(event) => {
            if (event.target)
            {   
                if (event.target.classList.contains('alternatives_link'))
                {
                    event.preventDefault();
                    window.richModal("<p>Alternative products list to appear here.</p>","Alternative Products");
                }
            }
        });

        sizeAndQuantitySelectorGroup.addEventListener('change',(event) => {
            if (event.target)
            {
                if (event.target.classList.contains('quantity_selector_quantity_field'))
                {
                    const quantityField = event.target;
                    const sizeQuantitySelector = quantityField.closest(".size_quantity_selector");
                    const product = quantityField.closest("article.product");
                    updateStickyAddToBasket();

                    if (quantityField.valueAsNumber > 0)
                    {
                        sizeQuantitySelector.classList.add("active");
                    }
                    else
                    {
                        sizeQuantitySelector.classList.remove("active");
                    }

                    //if this product has any variants with qty > 0
                    if (Array.from(product.querySelectorAll('.quantity_selector_quantity_field')).some(input => parseInt(input.value) > 0))
                    {
                        product.classList.add("active");
                    }
                    else
                    {
                        product.classList.remove("active");
                    }
                }
            }
        });
    });

    if (document.querySelector(".product_images_swiper img"))
    {
        initialiseSwiper();
    }

    if (productForm)
    {
        console.log(productForm);
        productForm.addEventListener('submit',(e) => {
            e.preventDefault();
            addToBasket();
        });
    }

});